import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationSectionOperationCreateRequest, ConfigurationSectionOperationResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section-operation/configuration-section-operation.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationSectionOperationService {
    async create(laboratoryId: number, request: ConfigurationSectionOperationCreateRequest): Promise<ConfigurationSectionOperationResponse> {
        const response = await axios.post<ConfigurationSectionOperationResponse>(`/configuration/laboratories/${laboratoryId}/sectionOperations`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationSectionOperationResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationSectionOperationResponse>>(`/configuration/laboratories/${laboratoryId}/sectionOperations`, { ...filterModel }, { params })
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/sectionOperations/batch`, { data: request })
        return response.data
    }
}

export const configurationSectionOperationService = new ConfigurationSectionOperationService()
